module.exports = __webpack_public_path__ + "static/media/slide-adapt.45baabd7.png";